module.exports = __webpack_public_path__ + "static/manitoba-ed86d8360416b241e3fb85cdecc9cdcd.png";